import { useTranslation } from "react-i18next";
import { SensitivitySlider } from "./SensitivitySlider";

const CATEGORY_SIGNALS = {
  product_usage: ["login"],
  communication: [
    "sentiment",
    "expansion_inquiry",
    "champion_leaving",
    "support_ticket_frequency",
    "support_ticket_avg_time_to_close",
  ],
  contract_metrics: ["mrr", "champion_left", "csm_feedback"],
  csat_nps: ["nps_score", "csat_score"],
};

export const SensitivityCategory = ({
  categoryKey,
  categoryValues,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  const signals = CATEGORY_SIGNALS[categoryKey] || [];

  const getCategoryTitle = () => {
    return t(
      `pages.settings.actionsSettings.sensitivity.categories.${categoryKey}`,
    );
  };

  const getSignalLabel = (signalKey) => {
    return t(`pages.settings.actionsSettings.sensitivity.signals.${signalKey}`);
  };

  const handleSignalChange = (signalKey, newValue) => {
    onChange(categoryKey, signalKey, newValue);
  };

  return (
    <div className="border-b border-gray-100 pb-4 last:border-b-0">
      <h3 className="mb-2 text-sm font-medium text-gray-900">
        {getCategoryTitle()}
      </h3>
      {signals.map((signalKey) => (
        <SensitivitySlider
          key={signalKey}
          signalKey={signalKey}
          label={getSignalLabel(signalKey)}
          value={categoryValues?.[signalKey] || "medium"}
          onChange={handleSignalChange}
          disabled={disabled}
        />
      ))}
    </div>
  );
};
